import React from 'react';
import SimpleCard from '../teal-react/components/organisms/SimpleCard';
import { useProductList } from '../graphql/queries';
import MaxBox from '../teal-react/components/atoms/MaxBox';
import SimpleSearch from '../teal-react/components/organisms/SimpleSearch';
import Utils from '../teal-react/utils';
import { Divider } from '@mui/material';
import SimpleTable from '../teal-react/components/organisms/SimpleTable';
import { Add } from '@mui/icons-material';
import { useAuth } from '../teal-react/utils/token';

interface ProductPickerParams {
  onSelect: (product: any) => void;
  selected?: number;
  onAddClick: (p: any) => void;
}
const ProductPicker = ({
  onSelect,
  selected,
  onAddClick,
}: ProductPickerParams) => {
  const [term, setTerm] = React.useState('');
  const [products, setProducts] = React.useState([]);
  const { data } = useProductList();
  const { user } = useAuth();

  const onFilter = (t: string) => {
    setTerm(t);
  };

  React.useEffect(() => {
    if (Boolean(data)) {
      setProducts(
        Utils.filterObjectArray(data.productList, term, [
          'name',
          'code',
          'shortname',
        ])
      );
    }
    // eslint-disable-next-line
  }, [data, term]);

  return (
    <>
      <SimpleCard
        header="Products"
        noGutter
        headeraction={
          user?.isRO
            ? undefined
            : {
                icon: <Add />,
                onClick: () => {
                  onAddClick({});
                },
              }
        }
      >
        <SimpleSearch onFilter={onFilter} />
        <Divider />
        <MaxBox>
          <SimpleTable
            data={products}
            row_limit={9999}
            row_action={onSelect}
            row_style={(r: any) => {
              if (r.id === selected) {
                return { backgroundColor: '#FEFACD' };
              }
            }}
            columns={[
              {
                header: 'Product Name',
                cell: 'name',
              },
              {
                header: 'Code',
                align: 'right',
              },
            ]}
          />
        </MaxBox>
      </SimpleCard>
    </>
  );
};

export default ProductPicker;
